export const DEFAULT_COLOR_OPTIONS = [
  '#4BCE97',
  '#F5CC47',
  '#6BC3E0',
  '#F77167',
  '#94C747',
  '#9E8FEF',
]
